import { TaskNotificationItem } from 'layout/inbox-notifications/close/reconciliation/task/TaskNotificationItem';

import type { ReconciliationNotification } from 'types/inbox-notifications/close/ReconciliationNotifications';

export function ReconciliationNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: ReconciliationNotification;
}) {
  const [itemType, ...restOfType] = type;

  switch (itemType) {
    case 'task':
      return <TaskNotificationItem type={restOfType} item={item} />;
    default:
      return (
        <div>Unknown reconciliation notification type: {type.join('.')}</div>
      );
  }
}
